module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-100.c8b0466f.jpg";